
<mat-card>
    <mat-card-header>
      <mat-card-title>{{pageTitle}}</mat-card-title>
    </mat-card-header>
<mat-card-content class="m-t-1">
<form [formGroup]="sponsorForm">
  @if (isVisit()) {
    <app-radio-input
      label="Do you have a family member in Australia who is willing to sponsor/support your application?"
      [control]="sponsorForm.controls.hasSponsor"
      [options]="[
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
      ]"></app-radio-input>
  }
  @if (shouldShowSponsorDetails()) {
 
    
    <app-select-input label="Title" [control]="sponsorForm.controls.title" [lookupItems]="titles" placeholder="Select a Title"></app-select-input>
    @if (sponsorForm.controls.title.value?.value === "Other") {
      <app-text-input label="Please specify title" [control]="sponsorForm.controls.titleOther"></app-text-input>
    }
    
    <app-text-input label="Sponsor's Given Names" [control]="sponsorForm.controls.firstName"></app-text-input>
    <app-text-input label="Sponsor's Surname / Family Name" [control]="sponsorForm.controls.surname"></app-text-input>
    <app-select-input label="Sponsor's Country of Passport" [control]="sponsorForm.controls.passportCountry" [lookupItems]="countries" placeholder="Select a Country"></app-select-input>
    <app-date-input label="Sponsor's Date of Birth" [control]="sponsorForm.controls.dob"></app-date-input>

    
    @if (isPartnerSponsoring()) {
      <app-select-input label="Country where the sponsor currently resides" [control]="sponsorForm.controls.countryResidence" [lookupItems]="countries" placeholder="Select a Country"></app-select-input>
      
      <app-radio-input
        label="Has the sponsor previously sponsored a partner to Australia?"
        [control]="sponsorForm.controls.previouslySponsored"
        [options]="[
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ]"></app-radio-input>
      @if (sponsorForm.controls.previouslySponsored.value === "true") {
        <app-text-input label="How many partners has the sponsor previously sponsored?" [control]="sponsorForm.controls.howManyPreviously"></app-text-input>
      }
    }
    
    
    @if(!isPartnerSponsoring()){

      <app-text-input label="Sponsor's Email Address" [control]="sponsorForm.controls.email" type="email"></app-text-input>
      <app-phone-input
        label="Sponsor's Best Contact Phone Number"
        [phoneTypeControl]="sponsorForm.controls.phoneType"
        [phoneCountryCodeControl]="sponsorForm.controls.phoneCountryCode"
        [phoneAreaCodeControl]="sponsorForm.controls.phoneAreaCode"
        [phoneNumberControl]="sponsorForm.controls.phoneNumber"></app-phone-input>
  
    
      @if (showHasPartner()) {
        <app-radio-input
          label="Does the sponsor have a Spouse/Partner who is cohabitating with them?"
          [control]="sponsorForm.controls.hasPartner"
          [options]="[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]"></app-radio-input>

        @if (showPartnerFields()) {
          <app-text-input label="Partner's Given Names" [control]="sponsorForm.controls.partnerName"></app-text-input>
          <app-text-input label="Partner's Family Name" [control]="sponsorForm.controls.partnerSurname"></app-text-input>
          <app-date-input label="Partner's Date of Birth" [control]="sponsorForm.controls.partnerDob"></app-date-input>
        }
      }
    }
 @if(!isPartnerSponsoring()){    
    <app-select-input label="What is the Sponsor's current Citizenship / Visa status in Australia?" [control]="sponsorForm.controls.visaStatus" [lookupItems]="visaStatus" placeholder="Select a Visa Status"></app-select-input>
    <app-select-input label="What is the Sponsor's marital status?" [control]="sponsorForm.controls.maritalStatus" [lookupItems]="maritalStatus" placeholder="Select a Marital Status"></app-select-input>
    <app-select-input label="What is the sponsor's current employment status?" [control]="sponsorForm.controls.employmentStatus" [lookupItems]="employmentStatus" placeholder="Select an Employment Status"></app-select-input>    
    }
    @else {
      <app-select-input label="What is the sponsor's current employment status?" [control]="sponsorForm.controls.employmentStatus" [lookupItems]="employmentStatus" placeholder="Select an Employment Status"></app-select-input> 
      <app-select-input label="What is the Sponsor's current Citizenship / Visa status in Australia?" [control]="sponsorForm.controls.visaStatus" [lookupItems]="visaStatus" placeholder="Select a Visa Status"></app-select-input>  
    }
          <!-- Cohabiting only applies to non-spouse sponsor -->
    
      @if(!isPartnerSponsoring()){
        @if (showRelationToApplicant()) {
          <app-select-input [label]="'The Sponsor is ' + getNameApplicantOwnership()" [control]="sponsorForm.controls.realtionToApplicant" [lookupItems]="relationTypes" placeholder="Select a Relationship" [errorMsg]="'Relation is required'"></app-select-input>
        }
        @if (showChildRelation()) {
          <app-select-input [label]="'The Sponsor is ' + getNameApplicantOwnership()" [control]="sponsorForm.controls.realtionToApplicant" [lookupItems]="parentRelationTypes" placeholder="Select a Relationship" [errorMsg]="'Relation is required'"></app-select-input>
        }
        @if (showParentRelation()) {
          <app-select-input [label]="'The Sponsor is ' + getNameApplicantOwnership()" [control]="sponsorForm.controls.realtionToApplicant" [lookupItems]="childRelationTypes" placeholder="Select a Relationship" [errorMsg]="'Relation is required'"></app-select-input>
        }
    }

  }
  
</form>
</mat-card-content>
</mat-card> 
